import './index.css';

import Info from './Info';
import { CompactTransaction } from '../../../../../types';

interface Props {
  compactTransactions: CompactTransaction[];
}

const TransactionSummary = (props: Props) => {
  const { compactTransactions } = props;

  return (
    <div className="transactions-summary-root">
      {/* <div className="transactions-summary-info-container">
        <Info />
      </div> */}
    </div>
  );
};

export default TransactionSummary;
